import type { SuggestedChannelCardProps } from './SuggestedChannelCard.types';
import { getPlatformConfig } from '@/shared/constants';
import { OptimizedImage } from '@/shared/ui/OptimizedImage';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SuggestedChannelCard = ({
  execution,
}: SuggestedChannelCardProps): React.JSX.Element => {
  const { t } = useTranslation('analysis');
  const platformConfig = getPlatformConfig(execution.platform);

  return (
    <div className="gap-4 rounded-lg p-6 h-full border border-border-light bg-card">
      {/* Header with Platform Badge */}
      <div className="flex justify-between gap-4 mb-2">
        <div>
          <div className="rounded w-8 h-8 flex items-center justify-center dark:bg-neutral-50">
            {platformConfig ? (
              <OptimizedImage
                src={platformConfig.image}
                alt={execution.platform}
                width={32}
                height={32}
              />
            ) : (
              <Globe size={32} />
            )}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-foreground text-base">{execution.title}</p>
          <p className="text-base text-foreground-alt">{execution.description}</p>
          <p className="text-xs text-foreground-alt">
            {t('socialMediaOpportunitiesWidget.suggestedChannelCard.source', {
              platform: execution.platform,
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
